import { Injectable } from '@angular/core';
import { CreateEffectMetadata } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { SciGuaduaHttpRequestHandler } from '@scifamek/guadua';
import { Observable } from 'rxjs';
import { createEntityEffects } from '../../../shared/base';
import {
  CreateResidentCommand,
  GetAllResidentsCommand,
  GetResidentByDocumentCommand,
  UploadDocumentOfResidentsCommand,
  UpdateResidentCommand,
  UpdateStatusResidentCommand,
  GetResidentByIdCommand,
} from './resident.commands';
import {
  CreatedResidentEvent,
  CreateResidentErrorEvent,
  GotAllResidentsEvent,
  GotResidentByDocumentEvent,
  GottenResidentDomainEvent,
  UpdatedResidentEvent,
  UpdatedStatusResidentEvent,
  UploadedDocumentOfResidentsEvent,
} from './resident.events';

@Injectable()
export class ResidentEffects {
  prefix = 'resident';
  createResidentCommand: Observable<Action<string>> & CreateEffectMetadata;
  getAllResidentsCommand: Observable<Action<string>> & CreateEffectMetadata;
  getResidentByDocumentCommand: Observable<Action<string>> & CreateEffectMetadata;
  getResidentByIdCommand: Observable<Action<string>> & CreateEffectMetadata;
  uploadDocumentOfResidentsCommand: Observable<Action<string>> & CreateEffectMetadata;
  updateResidentCommand: Observable<Action<string>> & CreateEffectMetadata;
  updateStatusResidentCommand: Observable<Action<string>> & CreateEffectMetadata;

  constructor(private sciGuaduaHttpRequestHandler: SciGuaduaHttpRequestHandler) {
    this.createResidentCommand = this.sciGuaduaHttpRequestHandler.handleEvent({
      command: CreateResidentCommand,
      prefix: 'resident',
      others: (httpResponse: any, commandData: any) => {
        if (httpResponse.meta?.code === 'Resident:ErrorShortPasswordDomainEvent') {
          return [];
        }
        const data = httpResponse.data;
        const entities = Array.isArray(data) ? data : data ? [data] : [];
        return [CreatedResidentEvent({ entities })];
      },
    });
    this.getAllResidentsCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      GetAllResidentsCommand,
      GotAllResidentsEvent,
      this.prefix,
    );

    this.getResidentByDocumentCommand = this.sciGuaduaHttpRequestHandler.handleEvent({
      command: GetResidentByDocumentCommand,
      prefix: this.prefix,
      others: (httpResponse: any, commandData: any) => {
        if (httpResponse.meta?.code !== 'Resident:GottenResidentDomainEvent') {
          return [];
        }
        const data = httpResponse.data;
        return [GotResidentByDocumentEvent({ entity: data })];
      },
    });
    this.getResidentByIdCommand = this.sciGuaduaHttpRequestHandler.handleEvent({
      command: GetResidentByIdCommand,
      prefix: this.prefix,
      others: (httpResponse: any, commandData: any) => {
        if (httpResponse.meta?.code !== 'Resident:GottenResidentDomainEvent') {
          return [];
        }
        const data = httpResponse.data;
        return [GottenResidentDomainEvent({ resident: data })];
      },
    });
    this.uploadDocumentOfResidentsCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      UploadDocumentOfResidentsCommand,
      UploadedDocumentOfResidentsEvent,
      this.prefix,
    );
    this.updateResidentCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      UpdateResidentCommand,
      UpdatedResidentEvent,
      this.prefix,
    );
    this.updateStatusResidentCommand = createEntityEffects(
      sciGuaduaHttpRequestHandler,
      UpdateStatusResidentCommand,
      UpdatedStatusResidentEvent,
      this.prefix,
    );
  }
}
